import {
  Tooltip,
  Typography,
  Input,
  Button,
  Switch,
  Pagination,
  Form,
  Empty,
} from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmationModal from "../../../../Modal/ConfirmationModal";
import { useState, useEffect } from "react";
import SortingArrow from "../../../../Common/SortingArrow";
import * as Validation from "../../../../utils/helper/validation";
import * as Apis from "../../../../utils/helper/enum";
import { changeLoader } from "../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import {
  paginationLimit,
  paginationPages,
} from "../../../../utils/helper/constants";

let timer = null;

const BranchesDetails = () => {
  let { id } = useParams();
  const [form] = Form.useForm();  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Search } = Input;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);

  const [itemData, setItemData] = useState(0);

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = { status: "deleted" };
      let response = await globalRequest(
        Apis?.MANAGE_VENDOR?.UPDATE_BRANCH_STATUS + "/" + itemData.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Branch deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllBrnaches();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };
  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };

  const getAllBrnaches = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
        id: id,
      };
      let response = await globalRequest(
        Apis.MANAGE_VENDOR.GET_ALL_BRANCH,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data);
        setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllBrnaches();
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleStatusChange = async (item) => {
    try {
      let value = { status: item.status === "active" ? "inactive" : "active" };
      let response = await globalRequest(
        Apis?.MANAGE_VENDOR?.UPDATE_BRANCH_STATUS + "/" + item.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Vendor active successfully";
        if (item.status === "active") msg = "Vendor inactive successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllBrnaches();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  return (
    <>
      <div className="block sm:flex justify-between	mb-4 gap-5">
        <div className="">
          <Typography className="text-xl font-semibold" align={"left"}>
            Manage Branches
          </Typography>
        </div>
        <div>
          <Search
            placeholder="Search by name"
            style={{
              width: window.innerWidth < 768 ? "100%" : 200,
            }}
            className="mx-1.5 cursor-pointer my-3 sm:my-0"
            onChange={(e) => {
              let value = Validation.strFormat(e.target.value, "trim");
              form.setFieldValue("search", value);
              setInputData((prev) => ({ ...prev, search: value }));
              setPaginationModel((prev) => ({ ...prev, page: 1 }));
            }}
          />
          <Button
            type="primary"
            size={14}
            icon={<PlusOutlined />}
            className="mx-1.5 cursor-pointer"
            onClick={() => navigate("/add-branch/" + id)}
          >
            Add Branch
          </Button>
        </div>
      </div>
      <div className="relative overflow-x-auto">
        <table className="w-full  text-left	 text-sm  text-gray-500">
          <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
            <tr>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Name{" "}
                <SortingArrow onSort={(order) => handleSort("name", order)} />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Address{" "}
                <SortingArrow
                  onSort={(order) => handleSort("address", order)}
                />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Zones
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Status
              </th>
              <th
                scope="col"
                className="px-3 py-3 text-center whitespace-nowrap vertical-top"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {list?.length ? (
              list?.map((item, index) => (
                <tr className="bg-white border-b" key={index}>
                  <td className="px-3 py-4 vertical-top whitespace-nowrap">
                    {item?.name}
                  </td>
                  <td className="px-3 py-4 vertical-top whitespace-nowrap">
                    {item?.address}
                  </td>
                  <td className="px-3 py-4 vertical-top whitespace-nowrap">
                    {item?.zoneDetails[0]?.name}
                  </td>
                  <td className="px-3 py-4 vertical-top">
                    <Switch
                      checked={item?.status === "active" ? true : false}
                      onChange={() => {
                        handleStatusChange(item);
                      }}
                    />
                  </td>
                  <td className="px-3 py-4 text-center whitespace-nowrap vertical-top">
                    <Tooltip title="Edit">
                      <EditOutlined
                        onClick={() =>
                          navigate("/edit-branch/" + id + "/" + item.id)
                        }
                        className="mx-1.5 cursor-pointer"
                      />
                    </Tooltip>
                    <Tooltip title="Delete">
                      <DeleteOutlined
                        className="mx-1.5 cursor-pointer"
                        onClick={() => {
                          setIsDeleteModalOpen(true);
                          setItemData(item);
                        }}
                      />
                    </Tooltip>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} className="text-center mt-3">
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="text-right mt-4">
        <Pagination
          defaultCurrent={1}
          total={totalRows}
          pageSizeOptions={paginationPages}
          showSizeChanger={true}
          current={paginationModel?.page}
          pageSize={paginationModel?.limit}
          onChange={(page) =>
            setPaginationModel((prev) => ({ ...prev, page: page }))
          }
          onShowSizeChange={(current, size) =>
            setPaginationModel((prev) => ({ ...prev, limit: size }))
          }
        />
      </div>
      {/* delete modal */}
      <ConfirmationModal
        ConfirmationHeading="Delete"
        ConfirmationParagraph="Are you sure you want to delete this Branch?"
        isOpen={isDeleteModalOpen}
        onOk={handleDeleteOk}
        onCancel={handleDeleteCancel}
      />
    </>
  );
};
export default BranchesDetails;
